import type { Language } from 'src/lib/utils'

import { I18nResource } from './constants'
import type { LangTranslation } from './types'

export const getResource = async (language: Language): Promise<LangTranslation | void> => {
  try {
    const translation = await require(`../../../public/locales/${I18nResource[language]}`)

    return { [language]: { translation } } as LangTranslation
  } catch {
    return void 0
  }
}
